import { FormRules, I18n } from '../types';

const createRules = <R extends FormRules>(rules: R) => rules;

export default createRules;